import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_b4ec139f952e61d6d44e5ae38927fa76/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import logger from 'common/utils/udp-logger';
import { getConfig } from 'portal-common/config';
import { CONFIG_KEYS } from 'portal-common/constants/requestConstants';
import request from 'portal-common/service/fetch';
import { buyLangMap } from '../common/constants';
import { getUserRemoteIP } from '../common/util';
import { getFormatUrlMethods } from '../components/OldRender/utils/url-utils';
import { getUserInfo } from './discountApi';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
export var getPriceTabData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lang, domains) {
        var langMap, sendLang, ref, data, code;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    langMap = buyLangMap;
                    sendLang = langMap[lang] || lang;
                    _ctx.next = 4;
                    return request.get('https://buy.tencentcloud.com/cgi/v2/config/getPriceTabData', {
                        params: {
                            csrfCode: '',
                            lang: sendLang
                        }
                    });
                case 4:
                    ref = _ctx.sent;
                    data = ref.data;
                    code = ref.code;
                    if (code) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        code: 0,
                        msg: '',
                        data: formatPriceTabData(data.blocks, domains)
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        code: code,
                        msg: '数据请求出错'
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPriceTabData(lang, domains) {
        return _ref.apply(this, arguments);
    };
}();
export var getTceTableData = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var ref, data, code;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return request.get('/render/api/configsolution/tceTableInfo', {
                        params: {}
                    });
                case 2:
                    ref = _ctx.sent;
                    data = ref.data;
                    code = ref.code;
                    if (code) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        code: 0,
                        msg: '',
                        data: data
                    });
                case 7:
                    return _ctx.abrupt("return", {
                        code: code,
                        msg: '数据请求出错'
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTceTableData() {
        return _ref.apply(this, arguments);
    };
}();
export var verifyCoupon = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req, res, RenderAjax, OpmAjax) {
        var ref, ref1, eventId, ecId, captcha, _isValidate, isValidate, formInfo, ip, ref2, ref3, randstr, ticket, config, res1, captCode, captData, ref4, _data, ownerUin, params, result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ref1 = req.body || {}, eventId = ref1.eventId, ecId = ref1.ecId, captcha = ref1.captcha, _isValidate = ref1.isValidate, isValidate = _isValidate === void 0 ? true : _isValidate, formInfo = ref1.formInfo;
                    ip = getUserRemoteIP(req);
                    if (!isValidate) {
                        _ctx.next = 20;
                        break;
                    }
                    ;
                    ref3 = captcha || {}, randstr = ref3.randstr, ticket = ref3.ticket;
                    _ctx.next = 8;
                    return getConfig(CONFIG_KEYS.secretConfig);
                case 8:
                    config = _ctx.sent;
                    _ctx.next = 11;
                    return OpmAjax.onDescribeCaptchaResult({
                        captcha_type: 9,
                        ticket: ticket,
                        user_ip: ip,
                        rand_str: randstr,
                        captcha_appid: config.captchaConf.appId,
                        app_secret_key: config.captchaConf.secretKey
                    }, {
                        timeout: 6 * 1000
                    });
                case 11:
                    res1 = _ctx.sent;
                    captCode = res1.code, captData = res1.data;
                    logger.info('verifyCoupon-capi.comApi', {
                        DescribeCaptchaResult: res1,
                        eventId: eventId,
                        ecId: ecId,
                        uin: ((req === null || req === void 0 ? void 0 : (ref2 = req.cookies) === null || ref2 === void 0 ? void 0 : ref2.uin) || '').replace(/^o0*/, ''),
                        ip: ip,
                        captcha: captcha
                    });
                    if (!(captCode !== 0)) {
                        _ctx.next = 17;
                        break;
                    }
                    logger.info('captData.CaptchaCode', {
                        captCode: captCode
                    });
                    return _ctx.abrupt("return", {
                        code: -1,
                        data: {},
                        msg: 'Intl Backend Service Error'
                    });
                case 17:
                    if (!(captData.captcha_code !== 1)) {
                        _ctx.next = 20;
                        break;
                    }
                    logger.info('captData.CaptchaCode', _objectSpread({}, captData));
                    return _ctx.abrupt("return", {
                        code: -2,
                        data: {},
                        msg: captData.captcha_msg
                    });
                case 20:
                    _ctx.next = 22;
                    return getUserInfo(req, res);
                case 22:
                    ref4 = _ctx.sent;
                    _data = ref4.data;
                    ownerUin = _data.owner_uin;
                    params = {
                        uin: ((req === null || req === void 0 ? void 0 : (ref = req.cookies) === null || ref === void 0 ? void 0 : ref.uin) || '').replace(/^o0*/, ''),
                        eventId: eventId,
                        ecId: ecId,
                        deviceIntelligence: {},
                        system: {
                            ip: ip
                        },
                        ownerUin: String(ownerUin),
                        formInfo: formInfo
                    };
                    _ctx.next = 28;
                    return RenderAjax.drawCommodityCoupon(params);
                case 28:
                    result = _ctx.sent;
                    logger.info('bugApi-FetchCommodity', {
                        params: params,
                        result: result
                    });
                    return _ctx.abrupt("return", result);
                case 31:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function verifyCoupon(req, res, RenderAjax, OpmAjax) {
        return _ref.apply(this, arguments);
    };
}();
var formatPriceTabData = function(data, domains) {
    var formatUrlString = getFormatUrlMethods({
        domains: domains
    }).formatUrlString;
    var ret = data.map(function(oneTab) {
        var title1 = oneTab.title, children = oneTab.children, doubleIcon = oneTab.doubleIcon;
        var childrenList = children.map(function(oneChild) {
            var title = oneChild.title, desc = oneChild.desc, to = oneChild.to, isCalcOnline = oneChild.isCalcOnline;
            return {
                title: title,
                text: desc,
                link: formatUrlString(to),
                hasCalculator: isCalcOnline
            };
        });
        return {
            title: title1,
            logo: doubleIcon,
            intro_list: childrenList
        };
    });
    return ret;
};
export var getRegisterStep = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req, res, RenderAjax) {
        var ref, code, _data, data, _uin, uin, tmp, ownerUin, params, result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getUserInfo(req, res);
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    _data = ref.data;
                    data = _data === void 0 ? {} : _data;
                    _uin = data.uin, uin = _uin === void 0 ? '' : _uin, tmp = data.owner_uin, ownerUin = tmp === void 0 ? '' : tmp;
                    if (!(code === 0 && uin)) {
                        _ctx.next = 17;
                        break;
                    }
                    if (!(Number(uin) !== Number(ownerUin))) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        code: 0,
                        data: {
                            step: 999
                        }
                    });
                case 10:
                    params = {};
                    params.uin = uin;
                    _ctx.next = 14;
                    return RenderAjax.getRegisterStep(params);
                case 14:
                    result = _ctx.sent;
                    logger.info('discountApi-getLoginInfo', {
                        result: result,
                        params: params
                    });
                    return _ctx.abrupt("return", result);
                case 17:
                    return _ctx.abrupt("return", {
                        code: -1000,
                        msg: '获取用户信息出错'
                    });
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getRegisterStep(req, res, RenderAjax) {
        return _ref.apply(this, arguments);
    };
}();
// 查询领劵前置开户状态+绑卡情况
export var getBillAccountInfo = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req, res, RenderAjax) {
        var ref, code, _data, data, ownerUin, ref5, ref6, _data1, isOpen, ref7, total;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getUserInfo(req, res);
                case 2:
                    ref = _ctx.sent;
                    code = ref.code;
                    _data = ref.data;
                    data = _data === void 0 ? {} : _data;
                    ownerUin = data.owner_uin;
                    if (!(code === 0 && ownerUin)) {
                        _ctx.next = 19;
                        break;
                    }
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 11;
                    return Promise.all([
                        getBillAccountIsOpenByUin({
                            uin: ownerUin
                        }, RenderAjax),
                        getBillAccountPaymentMethod({
                            uin: ownerUin,
                            page: 1,
                            page_size: 10
                        }, RenderAjax), 
                    ]);
                case 11:
                    _ctx.t1 = _ctx.sent;
                    ref5 = (0, _ctx.t0)(_ctx.t1, 2);
                    ref6 = ref5[0];
                    _data1 = ref6.data;
                    isOpen = _data1.is_open;
                    ref7 = ref5[1];
                    total = ref7.data.total;
                    return _ctx.abrupt("return", {
                        isOpen: isOpen,
                        total: total
                    });
                case 19:
                    return _ctx.abrupt("return", {
                        code: -1000,
                        msg: '获取用户信息出错'
                    });
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBillAccountInfo(req, res, RenderAjax) {
        return _ref.apply(this, arguments);
    };
}();
export var getBillAccountIsOpenByUin = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params, RenderAjax) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return RenderAjax.getBillAccountIsOpenByUin(params);
                case 2:
                    result = _ctx.sent;
                    logger.info('buyApi-getBillAccountIsOpenByUin', {
                        params: params,
                        result: result
                    });
                    return _ctx.abrupt("return", result);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBillAccountIsOpenByUin(params, RenderAjax) {
        return _ref.apply(this, arguments);
    };
}();
export var getBillAccountPaymentMethod = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params, RenderAjax) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return RenderAjax.getBillAccountPaymentMethod(params);
                case 2:
                    result = _ctx.sent;
                    logger.info('buyApi-getBillAccountPaymentMethod', {
                        params: params,
                        result: result
                    });
                    return _ctx.abrupt("return", result);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBillAccountPaymentMethod(params, RenderAjax) {
        return _ref.apply(this, arguments);
    };
}();
